import { Injectable } from '@angular/core';
import {
	HttpRequest,
	HttpHandler,
	HttpInterceptor,
	HTTP_INTERCEPTORS,
	HttpHeaders,
	HttpErrorResponse,
	HttpEvent
} from '@angular/common/http';
import { FacadeService } from '../services/facade.service';
import { catchError, EMPTY, Observable, switchMap, throwError } from 'rxjs';
import { AuthenticationService } from '../services/authentication/authentication.service';
import { AuthResponse } from 'src/app/shared/models/api-response/auth-response';

@Injectable({
	providedIn: 'root'
})
export class AuthInterceptor implements HttpInterceptor {
	private isRefreshing = false;
	
	constructor(private facade: FacadeService, private authService: AuthenticationService) {}

	intercept(req: HttpRequest<any>, next: HttpHandler): Observable<any> {
		let authReq = req;
		const token = this.facade.dataStorageService.getJwtToken();
		const tokenIsy = this.facade.dataStorageService.getTokenIsy();
		if (token !== null) {
			if (!req.url.includes('api-adresse') && !req.url.includes('affectation') && !this.authService.isTokenExpired(token)) {
				authReq = this.addTokenAndTimestampHeaders(req, token);
			}
		}

		if (tokenIsy !== null) {
			if (req.url.includes('affectation') && !req.url.includes('auth')) {
				authReq = this.addTokenAndTimestampHeaders(req, tokenIsy);
			}
		}

		return next.handle(authReq).pipe(
			catchError((error: HttpErrorResponse) => {
			  if ((error.status === 403 || error.status === 401) && !this.isRefreshing) {
				return this.handleError(req, next);
			  }
			  return next.handle(authReq);
			})
		  );
	}

	private addTokenAndTimestampHeaders(request: HttpRequest<any>, token: string) {
		let headers = new HttpHeaders({
			'Authorization': 'Bearer ' + token,
			'Timestamp': new Date().getTime() + ''
		});
		request = request.clone({
			headers: headers
		});
		// ajouter afin d'obtenir une HttpResponse complète avec Angular (cf : http-error-interceptor, l'obtention de header custom)
		request.params.append('observe', 'response');
		return request;
	}

	private handleError(req: HttpRequest<any>, next: HttpHandler) : Observable<HttpEvent<any>>{
		this.isRefreshing = true;
		const refreshToken = this.facade.dataStorageService.getRefreshToken();
		const username = this.facade.dataStorageService.getUser()?.username;

		this.facade.authenticationService.refreshToken(username, refreshToken).subscribe({
					next: (resp: AuthResponse) =>{
						this.facade.dataStorageService.setJwtToken(resp.jwtToken);
						this.facade.dataStorageService.setRefreshToken(resp.refreshToken);
						const newReq = req.clone({
							setHeaders: { Authorization: `Bearer ${resp.jwtToken}` }
						});
						this.isRefreshing = false;
						location.reload();
						return next.handle(newReq);
					},
					error: (error) => {
						this.authService.signOut();
						this.isRefreshing = false;
						return throwError(error);
					},
		})
		return EMPTY;
	}
	
		
}

export const authInterceptorProviders = [
	{ provide: HTTP_INTERCEPTORS, useClass: AuthInterceptor, multi: true }
];
